import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Overline } from "../components/Overline";
import { TESTIMONIALS } from "../lib/site";

export default function Testimonials() {
  return (
    <div data-testid="page-testimonials" className="bg-[#faf9f6]">
      <section className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <div className="max-w-3xl">
          <Overline>Words from women</Overline>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tighter leading-[1.04] font-normal text-[#333] mt-5">
            What changes
            <br />
            <span className="italic">when you're believed.</span>
          </h1>
        </div>

        <div data-testid="testimonials-carousel" className="mt-20 grid md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className={`relative p-10 md:p-12 rounded-3xl border border-[#e5e0d8] ${
                i % 3 === 0 ? "bg-[#cbdad6]/40" : "bg-white"
              }`}
            >
              <span className="font-serif text-7xl text-[#5fa292]/40 leading-none absolute top-4 left-6">
                "
              </span>
              <p className="font-serif text-xl md:text-2xl text-[#333] italic font-normal leading-relaxed mt-8">
                {t.quote}
              </p>
              <div className="mt-8 pt-6 border-t border-[#e5e0d8]">
                <p className="text-sm uppercase tracking-[0.2em] text-[#5fa292] font-medium">
                  {t.name}
                </p>
                <p className="text-xs text-[#3d3d3d] mt-1">{t.detail}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-20 text-center">
          <p className="font-serif text-2xl md:text-3xl italic text-[#3d3d3d] font-normal max-w-2xl mx-auto leading-relaxed">
            "Could you be next?"
          </p>
          <Link to="/contact" className="inline-block mt-8" data-testid="testimonials-cta">
            <Button className="bg-[#5fa292] hover:bg-[#4d8275] text-white rounded-full px-8 h-12">
              Book a discovery call
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
